var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var settings = require( "../../src/js/lib/settings" ),
Throttly = require('throttly'),
$window,
$mainWrapper,
$html,
$nav,
$megaContainer,
$header;

/**
 * Initializes the Info Bar.
 * @constructor
 * @param {Object} el - The hero element.
 * taken from ESNY
 */ 

	function adjustMenu() {
		var headerHeight = $header.height();
	}

	/**
 	* Adjust top content margin. This is because the height
 	* of the hello bar is variable.
 	*/
	function adjustContentMargin() {
		$mainWrapper.css( "margin-top", $header.height() );
	}

	function adjustMegaMenu() {
		$megaContainer.css( "top", $header.height() );
	}

	function adjustSearch() {
		$searchContainer.css( "top", $header.height() );
	}

	function initInfoBar( $el ) {
	$window = $( window );
	$html = $( "html" );
	$mainWrapper = $( ".main-wrapper" );
	content = $mainWrapper[ 0 ];
	
	var $infobar = $( ".js-info-bar" ),
		infobarRegexp = new RegExp( "(^|.*;\\s*)hide_infobar_" + $infobar.data( "hash" ) + "\\s*\\=\\s*1" );
		$infobar.css({
		"height": 0,
		"padding": 0,
		"display": "none"
	});

	// slide down info bar if it was not closed previously
	if ( !infobarRegexp.test( document.cookie ) ) {
		setTimeout(function() {
			$infobar.css({
				"height": "",
				"padding": ""
			});
			$infobar.slideDown({
				step: function() {
					adjustContentMargin();
					adjustMenu();
					adjustMegaMenu();
					adjustSearch();
				}
			});
		}, 5000 );
	}
	$infobar.on( "touchstart click", ".js-bar-close", function(e) {
		 e.preventDefault();
		 
		var expire = new Date();
		expire.setTime( expire.getTime() + 24 * 60 * 60 * 1000 );
		document.cookie = "hide_infobar_" + $infobar.data( "hash" ) + "=1; expires=" + expire.toGMTString();
		$infobar.slideUp({
			step: function() {
				adjustContentMargin();
				adjustMenu();
				adjustMegaMenu();
				adjustSearch();
			}
		});
	});

	var $eventbar = $( ".js-event-bar" ),
		eventbarRegexp = new RegExp( "(^|.*;\\s*)hide_infobar_" + $infobar.data( "hash" ) + "\\s*\\=\\s*1" );
		$eventbar.css({
		"height": 0,
		"padding": 0,
		"display": "none"
	});

	// slide down info bar if it was not closed previously
	if ( !eventbarRegexp.test( document.cookie ) ) {
		setTimeout(function() {
			$eventbar.css({
				"height": "",
				"padding": ""
			});
			$eventbar.slideDown({
				step: function() {
					adjustContentMargin();
					adjustMenu();
					adjustMegaMenu();
					adjustSearch();
				}
			});
		}, 5000 );
	}
	$eventbar.on( "touchstart click", ".js-event-close", function(e) {
		 e.preventDefault();

		var expire = new Date();
		expire.setTime( expire.getTime() + 24 * 60 * 60 * 1000 );
		document.cookie = "hide_infobar_" + $eventbar.data( "hash" ) + "=1; expires=" + expire.toGMTString();
		$eventbar.slideUp({
			step: function() {
				adjustContentMargin();
				adjustMenu();
				adjustMegaMenu();
				adjustSearch();
			}
		});
	});
	$window.on('resize', Throttly(adjustContentMargin, 50));
}

module.exports = function( el ) {
	$header = $( 'header' );
	$megaContainer = $( '.mega-menu__container' );
	$searchContainer = $( '.search__container-inner' );
	var $el = $header.children( ".header-container" );
	initInfoBar( $el );
};
